/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from "react";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  LinearProgress,
  FormGroup,
  FormLabel,
  Typography,
  Grid,
  Switch,
} from "@material-ui/core";

// Karsten
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import useLogs from "hooks/logs";

function DialogCreateOccurence({
  openCreateOccurence,
  onCloseDialog,
  idRegistroProblema,
  editOccurence,
}) {
  const snackbar = useSnackbar();
  const { setLocalStorageApiProblem } = useLogs();

  const [isActive, setIsActive] = useState(false);
  const [occurenceDescription, setOccurenceDescription] = useState("");
  const [creatingOccurence, setCreatingOccurence] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [hasChange, setHasChange] = useState(false);

  const handleAddOccurence = useCallback(async () => {
    setCreatingOccurence(true);

    await Api.post(
      "create-occurence-operation",
      "configuracoesOmni",
      {
        idRegistroProblema: idRegistroProblema,
        descricao: occurenceDescription,
      },
      true
    )
      .then((res) => {
        if (res.Success) {
          snackbar.showMessage(`Registro de ocorrência criado com sucesso!`, {
            severity: "success",
          });
          onCloseDialog("creating");
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "18",
          screen: "Pedidos Prateleira Infinita",
          problem: `Erro na chamada do endpoint create-occurence-operation - ${error}`,
        });
      })
      .finally(() => setCreatingOccurence(false));
  }, [occurenceDescription, snackbar]);

  const handleEditOccurence = useCallback(async () => {
    setCreatingOccurence(true);

    await Api.put(
      "edit-occurence-operation",
      "configuracoesOmni",
      {
        idRegistroProblemaOcorrencia:
          editOccurence?.IdRegistroProblemaOcorrencia,
        descricao: occurenceDescription,
        ativo: isActive,
      },
      true
    )
      .then((res) => {
        if (res.Success) {
          snackbar.showMessage(
            `Registro de ocorrência atualizado com sucesso!`,
            {
              severity: "success",
            }
          );
          onCloseDialog("editing");
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "18",
          screen: "Pedidos Prateleira Infinita",
          problem: `Erro na chamada do endpoint edit-occurence-operation - ${error}`,
        });
      })
      .finally(() => setCreatingOccurence(false));
  }, [occurenceDescription, editOccurence, isActive, snackbar]);

  const handleActiveChange = useCallback((event) => {
    setIsActive(event.target.checked);
    setHasChange(true);
  }, []);

  useEffect(() => {
    if (editOccurence) {
      setOccurenceDescription(editOccurence?.Observacao);
      setIsActive(editOccurence?.Ativo);
      setIsUpdating(true);
    }
  }, []);

  return (
    <Dialog
      open={openCreateOccurence}
      maxWidth="sm"
      keepMounted
      onClose={onCloseDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Typography variant="h3" component="h3">
          {isUpdating ? "Editar " : "Registrar "} Ocorrência
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Grid item xs={6} hidden={!isUpdating} style={{ marginTop: "-1rem" }}>
          <FormGroup
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <FormLabel
              style={{
                marginRight: "0.75rem",
                marginLeft: "-0.75rem",
                marginBottom: "-0.15rem",
              }}
            >
              Ativo
            </FormLabel>
            <Switch
              checked={isActive}
              onChange={handleActiveChange}
              size="small"
            />
          </FormGroup>
        </Grid>
        <FormGroup>
          <FormLabel required>Descrição</FormLabel>
          <TextField
            placeholder="Descrição"
            multiline
            rows={3}
            value={occurenceDescription}
            onChange={(event) => {
              setOccurenceDescription(event.target.value);
              setHasChange(true);
            }}
            variant="outlined"
            disabled={creatingOccurence}
            onInput={(e) =>
              (e.target.value = e.target.value.toString().slice(0, 6000))
            }
          />
        </FormGroup>
        {creatingOccurence && (
          <div>
            <span>
              {isUpdating ? "Atualizando " : "Registrando "} ocorrência...
            </span>
            <LinearProgress />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          component={Box}
          onClick={onCloseDialog}
          disabled={creatingOccurence}
        >
          Cancelar
        </Button>
        <Button
          component={Box}
          variant="contained"
          onClick={isUpdating ? handleEditOccurence : handleAddOccurence}
          disabled={
            occurenceDescription === "" || !hasChange || creatingOccurence
          }
        >
          {isUpdating ? "Atualizar" : "Registrar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export { DialogCreateOccurence };
